import React from 'react';
import clsx from 'clsx';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import { ITableHeadCell, ITableComponents } from '../types';
// import { useStyles } from './styles';
import { OrderValue } from 'types/common';

interface Props<T> {
    columns: ITableHeadCell[];
    order: OrderValue;
    orderBy: string;
    showActions: boolean;
    components: ITableComponents<T>;
    numSelected: number;
    rowCount: number;
    withCheckbox?: boolean;
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const EnhancedTableHead = <T extends { id: string }>({
    columns,
    order,
    orderBy,
    showActions,
    withCheckbox,
    numSelected,
    rowCount,
    components,
    onRequestSort,
    onSelectAllClick,
}: Props<T>) => {
    // const classes = useStyles();

    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    // const cellClassName = clsx(classes.cell, { [classes.roundedCell]: !components.Toolbar });
    // const checkboxCellClassName = clsx(classes.checkboxCell, { [classes.roundedCell]: !components.Toolbar });

    return (
        <TableHead>
            <TableRow
                sx={{
                    '&>*': {
                        '&:first-child': {
                            borderTopLeftRadius: 8,
                        },
                        '&:last-child': {
                            borderTopRightRadius: 8,
                        },
                    },
                }}
            >
                {withCheckbox && (
                    <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all items',
                            }}
                        />
                    </TableCell>
                )}
                {columns.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        sortDirection={orderBy === headCell.field ? order : false}
                        sx={{ backgroundColor: 'primary.light' }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.field && !headCell.disableSort}
                            direction={orderBy === headCell.field ? order : 'asc'}
                            onClick={headCell.disableSort ? undefined : createSortHandler(headCell.field)}
                            hideSortIcon={headCell.disableSort}
                        >
                            <Typography component="span" noWrap>
                                {headCell.label}
                            </Typography>
                        </TableSortLabel>
                    </TableCell>
                ))}
                {(showActions || components.Actions) && (
                    <TableCell
                        align="center"
                        sx={{ backgroundColor: 'primary.light' }}
                        // className={clsx(cellClassName, classes.actionCell, classes.labelText, 'actions-header-cell')}
                    >
                        Actions
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
};

export default EnhancedTableHead;
